import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {RouterModule} from '@angular/router'
import {FormsModule} from '@angular/forms'
import {NzModule} from '../../nz.module'
import {ImageEditorComponent} from './image.editor.component'
import {WizardComponent} from './wizard/wizard.component'
import {ImageEditorService} from './image.editor.service'
import {GetImageDimensionPipe, GetImagesByTagPipe} from './wizard/wizard.pipes'
import {NzImageModule} from 'ng-zorro-antd/image'
import {ScrollingModule} from '@angular/cdk/scrolling'
import {DragDropModule} from '@angular/cdk/drag-drop'
import {GlobalGalleryComponent} from './global-gallery/global.gallery.component'
import {ShowImageDirective} from './global-gallery/show.image.directive'
import {PipesModule} from '../../pipes.module'
import {VendorIconModule} from '../vendor-icon/vendor-icon.module'

@NgModule({
  declarations: [
    ImageEditorComponent,
    WizardComponent,
    GetImagesByTagPipe,
    GetImageDimensionPipe,

    // Global Gallery
    GlobalGalleryComponent,
    ShowImageDirective,
  ],
  imports: [
    NzModule,
    CommonModule,
    RouterModule,
    FormsModule,
    NzImageModule,
    ScrollingModule,
    DragDropModule,
    PipesModule,
    VendorIconModule
  ],
  providers: [
    ImageEditorService
  ],
  exports: [
    ShowImageDirective
  ]
})

export class ImageEditorModule {
  constructor() {
  }

}
